import { Box } from '@mantine/core'

import type { LabelProps } from '@/components/Label/Label.types'

import classes from './Label.module.css'

export function Label({ label, ...props }: LabelProps) {
  return (
    <Box className={classes.root} {...props}>
      <span dangerouslySetInnerHTML={{ __html: label }} />
    </Box>
  )
}
